/** Shared Recharts theme for Owner Intelligence (dark surfaces). */

export const OI_CHART = {
  grid: '#1f2937',
  axis: '#6b7280',
  primary: '#3b82f6',
  comparison: '#8b5cf6',
  positive: '#10b981',
  negative: '#ef4444',
  neutral: '#374151',
  target: '#f59e0b',
  tooltipBg: '#0a0e1a',
  tooltipBorder: '#3b82f6',
} as const;

export const oiChartMargin = { top: 8, right: 16, left: 0, bottom: 0 };

export function oiTooltipStyle() {
  return {
    background: OI_CHART.tooltipBg,
    border: `1px solid ${OI_CHART.tooltipBorder}`,
    borderRadius: 8,
    color: '#f9fafb',
    fontSize: 12,
  };
}

export function oiAxisTick() {
  return { fill: OI_CHART.axis, fontSize: 11 };
}
